import React, { Component } from 'react'
import DefaultFrame from '../components/DefaultFrame';
import UserShopSelector from './UserShopSelector';
import MediaManagerDialog from './mediamanager/MediaManagerDialog';
import { Button } from '@mui/material';

const TestWrapper = ({ children }) => {
    const micCheckStr = "test123MIC-CHECK";
    return React.cloneElement(children, { micCheckStr });
};


class TestChild extends React.Component {
    render() {
        return (
            <div>
                Hello World - PROPS={JSON.stringify(this.props)}
            </div>
        );
    }
}
export class Test extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedShops: [],
            mediaDialogOpen: true,

        }
    }

    // userId int NOT NULL, companyId int NOT NULL, shopId MEDIUMINT UNSIGNED NOT NULL, role TINYINT NOT NULL DEFAULT 2, UNIQUE(userId, shopId), FOREIGN KEY (userId) REFERENCES user(id)

    render() {
        console.log("myProps?: ", this.props);
        return (
            <div>
                <DefaultFrame noPermissionCheck>
                    <MediaManagerDialog
                        open={this.state.mediaDialogOpen}
                        onClose={() => {this.setState({ mediaDialogOpen: false })}}
                        onSelect={(fileItem) => {
                            console.log("Selected file item: ", fileItem);
                            this.setState({ mediaDialogOpen: false });
                        }}
                        typePreSelection="products"
                    />

                    {/* <div>
                        <UserShopSelector userId={3} selectedShops={this.state.selectedShops} setSelectedShops={(shops) => {this.setState({selectedShops: shops})}} />
                    </div> */}
                    {/* <div>Hello World - PROPS={JSON.stringify(this.props)}</div> */}
                    {/* <TestChild /> */}
                </DefaultFrame>
            </div>
        );
    }
}

export default Test;
